import React, { useState } from 'react';

export const CodeContext = React.createContext({});

export const CodeProvider = ({children}) => {
  const [ codeNumbers, setCodeNumbers ] = useState([]);

  return (
    <CodeContext.Provider
      value={{
        codeNumbers,
        setCodeNumbers
      }}
    >
      {children}
    </CodeContext.Provider>
  )
}

export const useCode = () => React.useContext(CodeContext);